// extracted by mini-css-extract-plugin
export var actions = "_4j-0";
export var actionsContainer = "_4j-7";
export var border = "_4j-1";
export var childFullHeight = "_4j-e";
export var collapse = "_4j-2";
export var content = "_4j-9";
export var contentChild = "_4j-d";
export var fullscreen = "_4j-b";
export var hasLeftRadius = "_4j-j";
export var headerContainer = "_4j-3";
export var headerRow = "_4j-5";
export var hidePadding = "_4j-a";
export var navCollapsedGap = "_4j-k";
export var noScrollX = "_4j-l";
export var noScrollY = "_4j-m";
export var noTopPadding = "_4j-h";
export var optOutTopPadding = "_4j-c";
export var pageMain = "_4j-i";
export var pageOuter = "_4j-f";
export var pagePadding = "_4j-8";
export var profile = "_4j-n";
export var profileContainer = "_4j-o";
export var profileImage = "_4j-p";
export var profileMain = "_4j-q";
export var profileSubtitle = "_4j-s";
export var profileTitle = "_4j-r";
export var showLeftPadding = "_4j-g";
export var tabsPortalSlot = "_4j-6";
export var tabsWrapper = "_4j-4";
export var title = "_4j-t";